import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    background: theme.palette.background.gray_50,
    padding: "4px",
    borderRadius: "10px",
    border: `1px solid ${theme.palette.background.gray_200}`,
    marginTop: "99px",
    [theme.breakpoints.down("960")]: {
      marginTop: "32px",
    },
    // Reset all MUI styles for children
    "& *": {
      boxShadow: "none",
      background: "none",
      border: "none",
      minWidth: "unset",
      minHeight: "unset",
      padding: "0",
      margin: "0",
      fontFamily: "inherit",
      fontSize: "inherit",
      color: "inherit",
      textTransform: "none",
      letterSpacing: "normal",
      outline: "none",
      boxSizing: "border-box",
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& .Mui-selected": {
      background: "none",
      color: "inherit",
    },
    "& .MuiTab-wrapper": {
      display: "flex",
      flexDirection: "row-reverse",
      gap: "4px",
    },
  },
  tabs: {
    display: "flex",
    alignItems: "center",
    gap: "0px",
    "& .MuiTabs-flexContainer": {
      display: "flex",
      alignItems: "center",
      gap: "0px",
    },
  },
  tabWrapper: {
    display: "flex",
    alignItems: "center",
  },
  tab: {
    all: "unset",
    fontWeight: 600,
    fontSize: "18px",
    color: theme.palette.text.text_quarterary,

    borderRadius: "8px",
    cursor: "pointer",
    padding: "8px 16px",
    marginRight: "8px",
    transition: "background 0.2s, box-shadow 0.2s",
    "&:hover": {
      background: theme.palette.background.gray_100,
    },
  },
  tabLabel: {
    fontWeight: 600,
    fontSize: "14px",
    color: "inherit",
  },
  closeIcon: {
    color: theme.palette.text.secondary,
    fill: theme.palette.text.placeholder,
    padding: "2px",
    background: "none",
    boxShadow: "none",
    margin: "0 !important",
  },
  addTabWrapper: {
    display: "flex",
    alignItems: "center",
  },
  addIcon: {
    color: theme.palette.text.primary,
    fill: theme.palette.text.primary,
    padding: "2px",
    background: "none",
    boxShadow: "none",
  },
  selectedTab: {
    background: `${theme.palette.background.paper} !important`,
    color: `${theme.palette.text.secondary} !important`,
    borderRadius: "6px",
    padding: "8px 12px",
    boxShadow:
      "0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)",
    transition: "background 0.2s, box-shadow 0.2s",
  },
}));
